import styled from 'styled-components';

export const MenuStyled = styled.div`
  height: 1000px;
  margin: 0 400px 50px 20px;

  @media(max-width: 400px){ 
    width: 100%; 
    margin: 0px; 
  }
`

